<template>
<!-- 标题 -->
  <div class="question-header">
    <div class="txtWrapper">
      <span class="otxt">{{mtitle}}</span>
    </div>
    <img @load='loadedImg' class="headerImg" v-loads='getImgAData' alt="">
  </div>
</template>

<script>
import img2Data from '@/components/QuestionHeader/images/banner@2x.png'
import img3Data from '@/components/QuestionHeader/images/banner@3x.png'
import {getRatio} from '@/libs/tools'
export default {
  name: 'QuestionHeader',
  props: ['mtitle'],
  data() {
    return {
      // tit: ''
    }
  },
  computed: {
    getImgAData() {
      if (getRatio() === 3) {
        return img3Data;
      } else {
        return img2Data
      }
    }
  },
  directives: {
    loads: {
      bind: function (el, binding, vnode) {
        var img = new Image();
        img.src = binding.value;
        var that = vnode.context;
        img.onload = function () {
          img.onload = null;
          el.src = img.src;
          setTimeout(() => {
          that.$emit('needInitialScroll');
        }, 50);
      }
     }
    }
  },
  methods: {
    loadedImg() {
      // console.log('load img');
    }
  },
  mounted() {
    // console.log('mtitle', this.mtitle)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/scss/const.scss';
@import '~@/common/scss/mixin.scss';

.question-header {
  position: relative;
  .txtWrapper {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: pxToRem(24);
    border-radius: 4px;
    height: pxToRem(38);
    width: 60%;
    /* border:1px solid red; */
    font-weight: 600;
    font-size: 0px;
    color: #ffffff;
    @include display-flex;
    @include flex-direction(row);
    @include align-items(center);
    @include justify-content(center);
    .otxt {
      font-size: 20px;
      letter-spacing: 1px;
      white-space: nowrap;
    }
  }
  .headerImg {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionHeader/QuestionHeader.vue